export default __webpack_public_path__ + "static/media/UI-logo.2af370c8.svg";